import type { FC, ReactNode } from 'react'

import { Quote, Star } from 'lucide-react'
import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { TESTIMONIALS } from '@/constants/content'

const initials = (name: string): string =>
    name
        .split(' ')
        .map(part => part.charAt(0))
        .join('')
        .slice(0, 2)
        .toUpperCase()

export const ReviewsSection: FC = (): ReactNode => {
    return (
        <section id='reviews' aria-labelledby='reviews-title' className='scroll-mt-20 bg-background py-20 sm:py-28'>
            <Container>
                <SectionHeading
                    id='reviews-title'
                    eyebrow='Reviews'
                    title='Drivers keep coming back'
                    description='A few words from people who trust us with their cars.'
                    align='center'
                />

                <ul className='mt-16 grid gap-6 lg:grid-cols-3'>
                    {TESTIMONIALS.map(review => (
                        <li key={review.name} className='relative flex flex-col rounded-[1.75rem] border border-border bg-card p-7 shadow-sm'>
                            <Quote aria-hidden='true' className='absolute right-7 top-7 size-9 text-aqua/50' />

                            <div className='flex gap-1' role='img' aria-label='Rated 5 out of 5'>
                                {Array.from({ length: 5 }, (_, index) => (
                                    <Star key={index} aria-hidden='true' className='size-4 fill-amber-400 text-amber-400' />
                                ))}
                            </div>

                            <blockquote className='mt-5 flex-1 text-lg leading-relaxed text-ink'>
                                <p>
                                    {review.quote}
                                </p>
                            </blockquote>

                            <div className='mt-7 flex items-center gap-3 border-t border-border pt-5'>
                                <span aria-hidden='true' className='grid size-11 place-items-center rounded-full bg-foam font-heading text-lg font-bold text-aqua-deep'>
                                    {initials(review.name)}
                                </span>

                                <div>
                                    <p className='font-semibold text-ink'>
                                        {review.name}
                                    </p>

                                    <p className='text-sm text-muted-foreground'>
                                        {review.vehicle}
                                    </p>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </Container>
        </section>
    )
}
